module.exports = __webpack_public_path__ + "img/WhatsApp Image 2019-11-21 at 4.32.06 PM (1).4e1e5597.jpeg";